module.exports = __webpack_public_path__ + "static/media/informatica.2ba61539.svg";